import { Component } from '@angular/core';

@Component({
  selector: 'app-intro-container',
  templateUrl: './intro-container.component.html',
  styleUrls: ['./intro-container.component.scss']
})
export class IntroContainerComponent {}
